import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { actions as getUserDocuments } from '../../../redux/profiles/get-user-documents';
import { actions as updateUserDocuments } from '../../../redux/profiles/update-user-documents';
import { actions as uploadUserDocuments } from '../../../redux/profiles/upload-user-documents';
import { actions as deleteUserDocuments } from '../../../redux/profiles/delete-user-documents';

import {
  selectUserDocumentsList,
  selectDocumentsPageLoading,
} from '../../../redux/profiles/selectors';
import {
  targetUserIdSelector,
  isLoggedUserSelector,
  selectIsVerifiedDependentRole,
} from '../../../redux/context/selectors';

import styles from '../index.styl';

const mapStateToProps = state => ({
  userId: targetUserIdSelector(state),
  isLoading: selectDocumentsPageLoading(state),
  userDocuments: selectUserDocumentsList(state),
  canEdit: isLoggedUserSelector(state) || selectIsVerifiedDependentRole(state),
});

const mapDispatchToProps = {
  getDocuments: getUserDocuments.send,
  clearDocuments: getUserDocuments.clear,
  uploadDocuments: uploadUserDocuments.send,
  updateDocuments: updateUserDocuments.send,
  deleteDocuments: deleteUserDocuments.send,
  deleteDocumentItem: getUserDocuments.deleteItem,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/enhance.js